const messages = {
  pt: {
    navbar: {
      home: 'Início',
      parks: 'Parques Tecnológicos',
      companies: 'Empresas',
      about: 'Institucional',
      contact: 'Contato',
      login: 'Entrar'
    },
    content: {
      news: 'Notícias',
      map: 'Mapa',
      tecnoparks: 'Parques Tecnológicos',
      parksInPlanningStage: 'Parques em Planejamento',
      parksInImplantationStage: 'Parques em Implantação',
      parksInOperationStage: 'Parques em Operação',
      byState: 'Por estado',
      selectState: 'Selecione um estado',
      selectStage: 'Selecione um estágio',
      byFocus: 'Por foco de atuação',
      selectFocus: 'Selecione um foco de atuação',
      notFound: 'Não Encontrado!',
      noParksFound: 'Nenhum parque encontrado.',
      search: 'Busca',
      mapLegendParks: 'Parques em operação por estado',
      mapLegendCompanies: 'Empresas vinculadas por estado',
      mapLegendBoth: 'Parques e empresas por estado',
      mapLegendEmpty: 'Marque parques e/ou empresas para ver a distribuição',
      mapTooltipParks: 'parques',
      mapTooltipCompanies: 'empresas'
    },
    commons: {
      park: 'Parque Tecnológico',
      name: 'Nome',
      email: 'Email',
      city: 'Cidade',
      state: 'Estado',
      companies: 'Empresas',
      about: 'Institucional',
      initials: 'Sigla',
      phoneNumber: 'Telefone',
      website: 'Website',
      legalResponsible: 'Responsável legal',
      stage: 'Estágio',
      planning: 'Planejamento',
      implantation: 'Implantação',
      operation: 'Operação'
    },
    portal: {
      revenues: 'Faturamento estimado',
      taxes: 'Impostos estimados',
      jobs: 'Empregos estimados',
      forTheYear: 'Referente a',
      contributors: 'Realização',
      project: 'Projeto',
      development: 'Desenvolvimento'
    },
    contact: {
      contact_us: 'Para mais informações, fale conosco!',
      our_email: 'E-mail',
      our_phones: 'Telefones',
      our_address: 'Endereço',
      form: {
        name: 'Seu nome completo',
        email: 'Seu endereço de e-mail',
        subject: 'Assunto',
        message: 'Mensagem',
        submit: 'Enviar',
        validation: {
          requiredField: 'Este campo é de preenchimento obrigatório.',
          invalidEmailAddress: 'Este campo deve ser preenchido com um endereço de e-mail válido.'
        },
        alerts: {
          success: 'Sua mensagem foi enviada!',
          error: 'Ocorreu um erro ao enviar a sua mensagem, por favor tente novamente mais tarde.'
        }
      }
    }
  },
  en: {
    navbar: {
      home: 'Home',
      parks: 'Science Parks',
      companies: 'Companies',
      about: 'About',
      contact: 'Contact',
      login: 'Login'
    },
    content: {
      news: 'News',
      map: 'Map',
      tecnoparks: 'Parks',
      parksInPlanningStage: 'Parks in Planning Stage',
      parksInImplantationStage: 'Parks in Implantation Stage',
      parksInOperationStage: 'Parks in Operation Stage',
      byState: 'By state',
      selectState: 'Select a state',
      selectStage: 'Select a stage',
      notFound: 'Not Found!',
      noParksFound: 'No parks have been found.',
      search: 'Search',
      mapLegendParks: 'Parks in operation by state',
      mapLegendCompanies: 'Linked companies by state',
      mapLegendBoth: 'Parks and companies by state',
      mapLegendEmpty: 'Check parks and/or companies to see distribution',
      mapTooltipParks: 'parks',
      mapTooltipCompanies: 'companies'
    },
    commons: {
      park: 'Park',
      name: 'Name',
      email: 'Email',
      city: 'City',
      state: 'State',
      companies: 'Companies',
      about: 'About',
      initials: 'Initials',
      phoneNumber: 'Phone Number',
      website: 'Website',
      legalResponsible: 'Legal Responsible',
      stage: 'Stage',
      planning: 'Planning',
      implantation: 'implantation',
      operation: 'Operation'
    },
    portal: {
      revenues: 'Estimated revenues',
      taxes: 'Estimated taxes',
      jobs: 'Estimated jobs',
      forTheYear: 'For the year',
      contributors: 'Contributors',
      project: 'Project',
      development: 'Development'
    },
    contact: {
      contact_us: 'Contact us for more informations!',
      our_email: 'Email',
      our_phones: 'Phones',
      our_address: 'Address',
      form: {
        name: 'Your name',
        email: 'Your email address',
        subject: 'Subject',
        message: 'Message',
        submit: 'Submit',
        validation: {
          requiredField: 'This field is required.',
          invalidEmailAddress: 'This field must have a valid e-mail address.'
        },
        alerts: {
          success: 'Your message was sent!',
          error: 'An error occurred, please try again alter.'
        }
      }
    }
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/i18n_translations.js